"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Layout = require("../../../../Layout");

var _Social = _interopRequireDefault(require("../../../../Social"));

var _MenuFooter = require("../MenuFooter.style");

var _FooterSocial = require("./FooterSocial.style");

var FooterSocial = function FooterSocial(_ref) {
  var media = _ref.media,
      text = _ref.text,
      rest = _objectWithoutProperties(_ref, ["media", "text"]);

  return /*#__PURE__*/_react.default.createElement(_FooterSocial.Wrapper, rest, /*#__PURE__*/_react.default.createElement(_Layout.Container, null, /*#__PURE__*/_react.default.createElement(_Layout.Grid, null, /*#__PURE__*/_react.default.createElement(_Layout.Column, {
    width: [12, 6, 6, 6, 9]
  }), /*#__PURE__*/_react.default.createElement(_Layout.Column, {
    width: [12, 6, 6, 6, 3]
  }, text && /*#__PURE__*/_react.default.createElement(_MenuFooter.FooterTitle, null, text), /*#__PURE__*/_react.default.createElement(_Social.default, {
    media: media,
    text: null,
    flexDirection: "row"
  })))));
};

FooterSocial.propTypes = {
  media: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  text: _propTypes.default.string
};
FooterSocial.defaultProps = {
  media: null,
  text: ''
};
var _default = FooterSocial;
exports.default = _default;